import lazyWithPreload from "../lazyWithPreload.tsx";

const AppMenuLoadable = lazyWithPreload(() => import("./index.tsx"));

export default AppMenuLoadable;
